@defer (when messages()) {
  @for (message of messages().items; track message.id) {
    @defer (on viewport) {
      <pp-notification
        [message]="message"
        [type]="type()"
        (markAsRead)="markAsRead.emit(message)" />
    } @placeholder {
      <div class="pp-shimmer"></div>
    }
  } @empty {
    <div class="empty-state">
      {{ 'notifications.dialog.tab.messages.emptyState' | translate }}
    </div>
  }

  @if (messages().itemsCount > messages().items.length) {
    <ng-container *puSpinner="loading()"></ng-container>
    <button
      class="load-more pp-medium-14"
      type="button"
      puButton
      size="s"
      uiType="quinary"
      (click)="loadMore.emit()">
      {{ 'notifications.dialog.tab.messages.loadMore' | translate }}
    </button>
  }
} @placeholder (minimum 1s) {
  @for (i of array; track $index) {
    <div class="pp-shimmer"></div>
  }
}
